import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import { games } from './../cjsStage';

import * as fJS from './../cjsRoot/fJS';
import { base, DynamicClass } from './cjsBase';

export class cjsGroup extends base {
  _sort;
  _shuffle;
  _items;
  _cols;
  _rows;
  _offsetItems;

  constructor(obj) {
    super();
    this._setStart(obj);
    this._sort = obj.sort;
    this._shuffle = obj.shuffle;
    this._items = {};
    this._cols = 0;
    this._rows = 0;
    this._offsetItems = [];
    this._offsetItems.push(obj.stage.defConfig.container.offset);
    this._block = true;
  }

  setLayout(prop, sets, layoutGroup, rules) {
    this._layout[prop] = _.merge(
      this._layout[prop],
      // sets: config.layout.groupsConfig.background
      sets.layout &&
        sets.layout.groupsConfig &&
        typeof sets.layout.groupsConfig[prop] === 'object' &&
        sets.layout.groupsConfig[prop] !== null
        ? sets.layout.groupsConfig[prop]
        : {},
      // config.layout.groups[x].background
      layoutGroup && typeof layoutGroup[prop] === 'object' && layoutGroup[prop] !== null
        ? _.cloneDeep(layoutGroup[prop])
        : {},
      // rulesGame.groupsConfig.background
      sets.rules &&
        sets.rules.groupsConfig &&
        typeof sets.rules.groupsConfig[prop] === 'object' &&
        sets.rules.groupsConfig[prop] !== null
        ? _.cloneDeep(sets.rules.groupsConfig[prop])
        : {},
      // rulesGame.items[x].background
      rules && rules.groupsConfig && typeof rules.groupsConfig[prop] === 'object' && rules.groupsConfig[prop] !== null
        ? _.cloneDeep(rules.groupsConfig[prop])
        : {}
    );
  }

  setMargin(prop, sets, layoutGroup, rules) {
    let tmpSets = [
      sets.layout &&
      sets.layout.groupsConfig &&
      typeof sets.layout.groupsConfig.positions === 'object' &&
      sets.layout.groupsConfig.positions[prop] !== undefined &&
      sets.layout.groupsConfig.positions[prop] !== null
        ? sets.layout.groupsConfig.positions[prop]
        : {},
      layoutGroup &&
      typeof layoutGroup.positions === 'object' &&
      layoutGroup.positions[prop] !== undefined &&
      layoutGroup.positions[prop] !== null
        ? _.cloneDeep(layoutGroup.positions[prop])
        : {},
      sets.rules &&
      sets.rules.groupsConfig &&
      typeof sets.rules.groupsConfig.positions === 'object' &&
      sets.rules.groupsConfig.positions[prop] !== undefined &&
      sets.rules.groupsConfig.positions[prop] !== null
        ? _.cloneDeep(sets.rules.groupsConfig.positions[prop])
        : {},
      rules &&
      rules.groupsConfig &&
      typeof rules.groupsConfig.positions === 'object' &&
      rules.groupsConfig.positions[prop] !== undefined &&
      rules.groupsConfig.positions[prop] !== null
        ? _.cloneDeep(rules.groupsConfig.positions[prop])
        : {},
    ];

    this.setPropMargin(tmpSets, prop);
  }

  addItem(obj, clone) {
    let self = this;
    this._stage.promises.push(
      new Promise((resolve, reject) => {
        if (typeof clone === 'string') self._items[clone] = obj;
        else self._items[obj.id] = new DynamicClass(self._stage.engine, _.merge(obj, { idGroup: self.id }));
        resolve(self._items[obj.id]);
      })
    );
  }

  setCorrects(groups) {
    for (let gr in groups) {
      if (typeof groups[gr].items !== 'object' || groups[gr].items === null)
        throw 'Brakuje konfiguracji tablicy items dla grupy: ' + gr;
      for (let item in groups[gr].items) {
        for (let i = 0; i < groups[gr].items[item].correct.length; i++) {
          let c = groups[gr].items[item].correct[i],
            exists = false;
          if (typeof groups[c.idGroup] !== 'object' || groups[c.idGroup] === null)
            throw 'Brakuje konfiguracji dla grupy: ' +
              c.idGroup +
              ' z tablicy correct grupy: ' +
              gr +
              ' i elementu: ' +
              item;
          if (typeof groups[c.idGroup].items[c.idItem] !== 'object' || groups[c.idGroup].items[c.idItem] === null)
            throw 'Brakuje konfiguracji dla elementu: ' +
              c.idItem +
              ' z tablicy correct grupy: ' +
              gr +
              ' i elementu: ' +
              item;

          for (let j = 0; j < groups[c.idGroup].items[c.idItem].correct.length; j++) {
            exists =
              groups[c.idGroup].isEqual(_.cloneDeep(groups[c.idGroup].items[c.idItem].correct[j]), {
                idGroup: gr,
                idItem: item,
              }) === true
                ? true
                : exists;
          }

          if (exists === false) {
            groups[c.idGroup].items[c.idItem].correct.push(_.merge(_.cloneDeep(c), { idGroup: gr, idItem: item }));
          }
        }
      }
    }
  }

  create() {
    this.createContainer();

    this.x -= this._stage.offset.x;
    this.y -= this._stage.offset.y;

    let iW = 0,
      iH = 0;

    for (let i in this._items) {
      if (this._items[i].isAbsolute() && this._items[i].otherProperty && this._items[i].otherProperty.positionFrom) {
        let pF = this._items[i].otherProperty.positionFrom;
        this._items[i].pos.x -= this.pos.x;
        this._items[i].pos.y -= this.pos.y;

        this._items[i].x = this._items[i].pos.x;
        this._items[i].y = this._items[i].pos.y;
      }

      iW = this._items[i].x + this._items[i].width + this._items[i].margin.right + this.padding.right;
      iH = this._items[i].y + this._items[i].height + this._items[i].margin.bottom + this.padding.bottom;
      if (this.pos.width < iW) this.pos.width = iW;
      if (this.pos.height < iH) this.pos.height = iH;

      this._container.addChild(this._items[i].container);
    }
  }

  _setPositionFromAnotherItem(i, ac, flg) {
    let pF = this._items[i].otherProperty.positionFrom;
    if (
      typeof pF.idGroup !== 'string' ||
      this._stage.groups[pF.idGroup] === undefined ||
      this._stage.groups[pF.idGroup] === null ||
      (pF.idGroup === this.id && flg !== true)
    )
      throw 'Błędna konfiguracja idGroup z positionFrom dla grupy: ' + this.id;
    if (
      typeof pF.idItem !== 'string' ||
      this._stage.groups[pF.idGroup].items[pF.idItem] === undefined ||
      this._stage.groups[pF.idGroup].items[pF.idItem] === null
    )
      throw 'Błędna konfiguracja idItem z positionFrom dla grupy: ' + this.id;
    if (
      typeof pF.idHook === 'string' &&
      (this._stage.groups[pF.idGroup].items[pF.idItem].hooks[pF.idHook] === undefined ||
        this._stage.groups[pF.idGroup].items[pF.idItem].hooks[pF.idHook] === null)
    )
      throw 'Błędna konfiguracja idHook z positionFrom dla grupy: ' + this.id;

    //     this._items[i]._type = 'absolute';
    let item,
      isHook = false;
    if (typeof pF.idHook === 'string') {
      item = this._stage.groups[pF.idGroup].items[pF.idItem].hooks[pF.idHook];
      isHook = true;
    } else {
      if (
        typeof this._stage.groups[pF.idGroup].items[pF.idItem].hooks === 'object' &&
        Object.keys(this._stage.groups[pF.idGroup].items[pF.idItem].hooks).length > 0
      ) {
        let h = Object.keys(this._stage.groups[pF.idGroup].items[pF.idItem].hooks)[ac];
        item = this._stage.groups[pF.idGroup].items[pF.idItem].hooks[h];
        ac++;
        isHook = true;
      } else {
        item = this._stage.groups[pF.idGroup].items[pF.idItem];
      }
    }

    let pt;
    if (isHook === true) {
      let st = item.container.localToGlobal(this._stage.groups[pF.idGroup].pos.x, this._stage.groups[pF.idGroup].pos.y);
      pt = this._items[i].container.globalToLocal(st.x + this.pos.x, st.y + this.pos.y);
    } else {
      //  this.pos = _.cloneDeep(this._stage.groups[pF.idGroup].pos);
      //  pt = item.container.localToLocal(this._stage.groups[pF.idGroup].pos.x, this._stage.groups[pF.idGroup].pos.y, this._items[i].container);
      //  console.log('x: ' + this._stage.groups[pF.idGroup].pos.x + ' - ' + this._stage.groups[pF.idGroup].pos.y);
      /*      let st = item.container.localToGlobal(this._stage.groups[pF.idGroup].pos.x, this._stage.groups[pF.idGroup].pos.y);
          pt = this._items[i].container.globalToLocal(st.x + this.pos.x, st.y + this.pos.y);
          console.log(this._items[i]._layout);
          console.log('PARENT: ' + this.pos.x + ' ' + this.pos.y);*/
      pt = item.container.localToLocal(
        this._stage.groups[pF.idGroup].pos.x,
        this._stage.groups[pF.idGroup].pos.y,
        this._items[i].container
      );
      pt.x += this._items[i].offset.x;
      pt.y += this._items[i].offset.y;
    }
    this._items[i].x = this._items[i].pos.x = pt.x;
    this._items[i].y = this._items[i].pos.y = pt.y;

    return ac;
  }

  get sort() {
    return this._sort;
  }
  get shuffle() {
    return this._shuffle;
  }
  get items() {
    return this._items;
  }
  get cols() {
    return this._cols;
  }
  set cols(v) {
    if (!fJS.isNumeric(v) || v < 0) throw 'Nieprawidłowa liczba kolumn dla grupy: ' + this.id;
    this._cols = v;
  }
  get rows() {
    return this._rows;
  }
  set rows(v) {
    if (!fJS.isNumeric(v) || v < 0) throw 'Nieprawidłowa liczba wierszy dla grupy: ' + this.id;
    this._rows = v;
  }

  setOffsetItems(stage, layoutGroup, rules, sets) {
    if (
      sets.layout &&
      sets.layout.itemsConfig &&
      sets.layout.itemsConfig.positions &&
      sets.layout.itemsConfig.positions.offset !== undefined &&
      sets.layout.itemsConfig.positions.offset !== null
    ) {
      this._checkOffsetItem(stage, sets.layout.itemsConfig.positions.offset);
    }
    if (
      layoutGroup &&
      layoutGroup.itemsConfig &&
      layoutGroup.itemsConfig.positions &&
      layoutGroup.itemsConfig.positions.offset !== undefined &&
      layoutGroup.itemsConfig.positions.offset !== null
    ) {
      this._checkOffsetItem(stage, layoutGroup.itemsConfig.positions.offset);
    }
    if (
      sets.rules &&
      sets.rules.itemsConfig &&
      sets.rules.itemsConfig.positions &&
      sets.rules.itemsConfig.positions.offset !== undefined &&
      sets.rules.itemsConfig.positions.offset !== null
    ) {
      this._checkOffsetItem(stage, sets.rules.itemsConfig.positions.offset);
    }
    if (
      rules &&
      rules.itemsConfig &&
      rules.itemsConfig.positions &&
      rules.itemsConfig.positions.offset !== undefined &&
      rules.itemsConfig.positions.offset !== null
    ) {
      this._checkOffsetItem(stage, rules.itemsConfig.positions.offset);
    }
  }

  _checkOffsetItem(stage, tab) {
    let self = this;
    this._offsetItems.splice(0, this._offsetItems.length);
    if (Array.isArray(tab)) {
      tab.forEach(function(off) {
        self._offsetItems.push({
          x: fJS.isNumeric(off.x) ? off.x : stage.defConfig.container.offset.x,
          y: fJS.isNumeric(off.y) ? off.y : stage.defConfig.container.offset.y,
          column: off.column,
          row: off.row,
        });
      });
    } else {
      this._offsetItems.push({
        x: fJS.isNumeric(tab.x) ? tab.x : stage.defConfig.container.offset.x,
        y: fJS.isNumeric(tab.y) ? tab.y : stage.defConfig.container.offset.y,
        column: tab.column,
        row: tab.row,
      });
    }
  }

  stageMouseDown(e, data) {
    console.log('cjsGroup: DOWN');
    e.stopPropagation();
  }

  stageMouseUp(e, data) {
    console.log('cjsGroup: UP');
    e.stopPropagation();
  }
}
